import React from "react";
import "./TabMenu.css";

const TABS = [
  { id: "addcontent", label: "Add Content" },
  { id: "questions", label: "Questions" },
];

export default function TabMenu({ activeTab, onTabChange }) {
  return (
    <div className="tabmenu">
      <nav className="tabmenu-nav">
        {TABS.map(({ id, label }) => (
          <button
            key={id}
            type="button"
            className={`tabmenu-tab ${activeTab === id ? "tabmenu-tab--active" : ""}`}
            onClick={() => onTabChange(id)}
          >
            {label}
          </button>
        ))}
      </nav>
    </div>
  );
}
